import store from "../app/store";

const CatchCrawlRes = async (botId, urls) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/crawl/catch-crawl-res`;

  const token = store.getState().auth.token;

  if (!token) {
    return {
      error: "No token found",
      data: null,
      msg: "Authentication failed",
    };
  }

  try {
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        botId,
        url: urls,
      }),
    };

    const response = await fetch(url, options);
    const result = await response.json();

    if (!response.ok) {
      return {
        error: result.error || "Request failed",
        data: null,
        msg: result.message || "Failed",
      };
    }

    return { error: null, data: result.urls, msg: result.message || "Success" };
  } catch (err) {
    console.error("CatchCrawlRes error:", err.message);
    return { error: err.message, data: null, msg: "Internal error" };
  }
};

export default CatchCrawlRes;
